import * as React from "react";
const SvgMic = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={27} {...props}>
    <g fill={props.fill} fillRule="evenodd">
      <path d="M8.919 15.175a3.78 3.78 0 0 0 3.768-3.769V3.87A3.78 3.78 0 0 0 8.92.1 3.78 3.78 0 0 0 5.15 3.869v7.537a3.78 3.78 0 0 0 3.769 3.769" />
      <path d="M15.991 10.15a.884.884 0 0 0-.884.884v.668c0 3.145-2.254 5.952-5.374 6.352a6.196 6.196 0 0 1-7.002-6.136v-.884a.884.884 0 0 0-1.768 0v.612c0 4.117 3.021 7.717 7.072 8.17v4.478H5.383a.884.884 0 0 0 0 1.768h7.072a.884.884 0 0 0 0-1.768H9.803v-4.478c3.977-.441 7.072-3.804 7.072-7.898v-.884a.884.884 0 0 0-.884-.884" />
    </g>
  </svg>
);
export default SvgMic;
